import { createContext, useCallback, useContext, useState, type PropsWithChildren } from 'react'
import { NavV3OptOutSurveyController } from './NavV3OptOutSurveyController'

// Provider/context for the v3 → v2 nav opt-out survey. Lives ABOVE the nav so
// the modal survives the v3 → v2 switch that unmounts NavVersionSwitcherButton
// — without this, clicking "Switch to classic" would unmount the trigger and
// any modal it owned in the same render before the modal could open.
//
// The trigger (NavVersionSwitcherButton with target='v2') calls openSurvey();
// the controller renders here, so it lives independently of the nav. The
// modal opens on every switch — no cooldown — so users see the June 30
// permanence notice each time they revert.
type NavV3OptOutSurveyContextValue = {
  openSurvey: () => void
}

const NavV3OptOutSurveyContext = createContext<NavV3OptOutSurveyContextValue>({
  openSurvey: () => {},
})

export const useNavV3OptOutSurvey = () => useContext(NavV3OptOutSurveyContext)

export const NavV3OptOutSurveyProvider = ({ children }: PropsWithChildren<{}>) => {
  const [isOpen, setIsOpen] = useState(false)

  const openSurvey = useCallback(() => setIsOpen(true), [])
  const onClose = useCallback(() => setIsOpen(false), [])

  return (
    <NavV3OptOutSurveyContext.Provider value={{ openSurvey }}>
      {children}
      {isOpen && <NavV3OptOutSurveyController onClose={onClose} />}
    </NavV3OptOutSurveyContext.Provider>
  )
}
